var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{attrs:{"id":"map1"}}),_c('div',{staticClass:"year"},[_c('a-icon',{attrs:{"type":"calendar"}}),_c('span',[_vm._v("2021")])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }